export default "__VITE_ASSET__XFJita15__"